import { render, staticRenderFns } from "./CDRepositories.vue?vue&type=template&id=09c3f4e4&scoped=true"
import script from "./CDRepositories.vue?vue&type=script&lang=ts"
export * from "./CDRepositories.vue?vue&type=script&lang=ts"
import style0 from "./CDRepositories.vue?vue&type=style&index=0&id=09c3f4e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c3f4e4",
  null
  
)

export default component.exports